// Centralized query keys for consistent caching
export const queryKeys = {
  // Notes
  notes: {
    all: ['notes'] as const,
    lists: () => [...queryKeys.notes.all, 'list'] as const,
    list: (filters: Record<string, any> = {}) => [...queryKeys.notes.lists(), { filters }] as const,
    details: () => [...queryKeys.notes.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.notes.details(), id] as const,
    shared: () => [...queryKeys.notes.all, 'shared'] as const,
    collaborators: (noteId: string) => [...queryKeys.notes.all, 'collaborators', noteId] as const,
  },

  // Organizations
  orgs: {
    all: ['orgs'] as const,
    list: () => [...queryKeys.orgs.all, 'list'] as const,
    members: (orgId: string) => [...queryKeys.orgs.all, 'members', orgId] as const,
  },
  
  // Collections
  collections: {
    all: ['collections'] as const,
    lists: () => [...queryKeys.collections.all, 'list'] as const,
    list: (filters: Record<string, any> = {}) => [...queryKeys.collections.lists(), { filters }] as const,
    details: () => [...queryKeys.collections.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.collections.details(), id] as const,
  },
  
  // Tabs
  tabs: {
    all: ['tabs'] as const,
    windows: () => [...queryKeys.tabs.all, 'windows'] as const,
    collections: () => [...queryKeys.tabs.all, 'collections'] as const,
  },

  // Tasks
  tasks: {
    all: ['tasks'] as const,
    list: (includeArchived = false) => [...queryKeys.tasks.all, { includeArchived }] as const,
  },
  
  // Auth
  auth: {
    all: ['auth'] as const,
    user: () => [...queryKeys.auth.all, 'user'] as const,
  },
} as const;
